// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Prepare_wrapper__-0LA0","body":"Prepare_body__3ucle"};